import React from "react";

// UTILS
import iconMap from "utils/iconMap";

// SERVICES
import { insertTileStat } from "services/statService";

const Folder = ({ user_id, tile_id, title, url, folderColor = "#F3F5F7", isEditing, isViewing }) => {
    const FolderIcon = iconMap["folder"];

    return (
        <>
            {!isEditing && !isViewing ? (
                <a className="flex items-center gap-4" href={url} target="_blank" rel="noopener noreferrer" onClick={() => insertTileStat(user_id, tile_id)}>
                    {/* Folder Icon & Icon */}
                    <div className="relative">
                        <FolderIcon className="size-10" style={{ fill: folderColor }} />
                    </div>
                    {/* Title */}
                    <div>
                        <p className="text-sm poppins-bold text-blanc">
                            {title}
                        </p>
                    </div>
                </a>
            ) : (
                <div className="flex items-center gap-4">
                    {/* Folder Icon & Icon */}
                    <div className="relative">
                        <FolderIcon className="size-10" style={{ fill: folderColor }} />
                    </div>
                    {/* Title */}
                    <div>
                        <p className="text-sm poppins-bold text-blanc">
                            {title}
                        </p>
                    </div>
                </div>
            )}
        </>
    );
}

export default Folder;